import { Download, Image, Play } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CardMediaFileProps } from './CardMediaFile.types';

const CardMediaFile = ({
  typeMedia = 'dashboard',
  mediaType = 'image',
  fileName,
  totalFile,
  img,
  onDownload,
  onClick,
}: CardMediaFileProps) => {
  if (typeMedia !== 'dashboard') {
    return (
      <div className=" gap-3 bg-background border rounded-[12px] min-w-[200px] p-3 flex flex-row items-center">
        <Image />
        <span className="title3medium ">{fileName}</span>
        <button onClick={onDownload} type="button" className="cursor-pointer">
          <Download />
        </button>
      </div>
    );
  }

  const cardStyle = cn(
    'gap-3 bg-background border rounded-[12px] min-w-[300px] p-3 flex flex-row items-start text-left',
    onClick && 'cursor-pointer hover:border-text-blue-100 transition-colors'
  );

  const card = (
    <>
      {mediaType === 'video' ? (
        // A video's own URL is not an image; rendering it as one leaves a
        // broken thumbnail, so the tile stands in for the frame.
        <div className="flex w-[60px] h-[60px] shrink-0 items-center justify-center rounded-[12px] bg-black/80 text-white">
          <Play />
        </div>
      ) : (
        <img
          src={img}
          alt={fileName}
          className="bg-cover w-[60px] h-[60px] rounded-[12px] shrink-0"
        />
      )}
      <div className="flex flex-col gap-1 min-w-0">
        <span className="title1 text-text-blue-100 underline truncate" title={fileName}>
          {fileName}
        </span>
        <span className="title1 text-text-grey">{totalFile}</span>
      </div>
    </>
  );

  // A real button only where there is something to open, so the cards that are
  // pure listing (report registration) stay non-interactive.
  return onClick ? (
    <button type="button" onClick={onClick} className={cardStyle}>
      {card}
    </button>
  ) : (
    <div className={cardStyle}>{card}</div>
  );
};

export default CardMediaFile;
